import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { MangopayTransactionStatus } from '#src/__generated__/globalTypes.ts';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { Dialog } from '#src/components/dialog/index.tsx';
import { DialogKey } from '#src/components/navigation/WithDialogs/index.tsx';
import { DepositAcceptedContent } from '#src/components/wallet/BankEthAccounting/AddFundsToFiatWallet/DepositAcceptedContent/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useWalletDrawerContext } from '#src/contexts/walletDrawer/index.tsx';
import { useCloseDialog } from '#src/hooks/navigation/useCloseDialog.ts';
import { useDialogParam } from '#src/hooks/navigation/useDialogParam.ts';
import { useFetchTransactionStatus } from '#src/hooks/useFetchTransactionStatus.ts';

const Root = styled(Vertical).attrs({ gap: 2, center: true })`
  padding: 0 var(--triple-unit) var(--triple-unit);
  text-align: center;
  justify-content: flex-start;
`;

export const DepositAcceptedDialog = () => {
  const { currentUser } = useCurrentUserContext();
  const { toggleDrawer } = useWalletDrawerContext();
  const [open, setOpen] = useState(false);
  const [fetchTransactionStatus] = useFetchTransactionStatus();
  const transactionId = useDialogParam(DialogKey.paypalTransactionId);
  const closeDialog = useCloseDialog();
  const skip = !currentUser;

  useEffect(() => {
    async function fetchData() {
      if (!transactionId || open) return;
      const response = await fetchTransactionStatus({
        variables: {
          transactionId,
        },
      });
      if (
        response.data?.mangopay.remoteTransactionStatus?.status &&
        [
          MangopayTransactionStatus.CREATED,
          MangopayTransactionStatus.SUCCEEDED,
        ].includesValue(response.data.mangopay.remoteTransactionStatus.status)
      ) {
        setOpen(true);
        toggleDrawer();
      }
    }
    if (!skip) {
      fetchData();
    }
  }, [skip, transactionId, open, fetchTransactionStatus, toggleDrawer]);

  if (skip) return null;

  return (
    <Dialog
      open={open}
      onClose={() => {
        closeDialog(DialogKey.paypalTransactionId);
        setOpen(false);
      }}
      maxWidth="xs"
      fullWidth
    >
      <Root>
        <DepositAcceptedContent />
      </Root>
    </Dialog>
  );
};
